export interface IShopSignInEditingModel {
  catalogCode: string;
}

export class ShopSignInEditingModel implements IShopSignInEditingModel
{
  public catalogCode: string = '';
}